/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_AudienceInputs */



/**
* | output |
* | --- |
* | "For n8n, Make, Zapier builders, and software vendors embedding oneAI as a backend." |
*
* @param {Gateway_Card_AudienceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_audience = /** @type {((inputs?: Gateway_Card_AudienceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_AudienceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für n8n-, Make-, Zapier-Builder und Software-Anbieter, die oneAI als Backend einbetten.")
	return /** @type {LocalizedString} */ ("For n8n, Make, Zapier builders, and software vendors embedding oneAI as a backend.")
});